import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardImg,
    CardText,
    Label
} from "reactstrap";
import { AvForm, AvField, AvRadioGroup, AvRadio } from 'availity-reactstrap-validation';
import Select from "react-select";
import FileUpload from "components/Common/file-upload/file-upload.component";
import Language from "Enums/Language"
import SelectOptions from "components/SelectOptions"
import FinishingTypesService from "services/Admin/FinishingTypesService"
import UnitTypesService from "services/Admin/UnitTypesService"
import PaymentService from "services/Admin/PaymentService"
import { adminAmenitiesOptions } from "Enums/fixedData"
import CategoriesService from "services/Admin/CategoriesService"
import BuildingService from "services/Admin/BuildingService"
import PropertyService from "services/Admin/PropertyService"
import { SuccessCreated, SuccessOk } from "configs/statusCode";
import { toast } from "react-toastify";
import { adminPrefix } from "configs/routePrefix";
import { payment_methods } from "Enums/fixedData"
import UnitOptions from "Enums/UnitOptions"
import PaymentPlanService from "services/Admin/PaymentPlanService"
import blankImg from "assets/images/blank.png";
import PriceInput from "components/PriceInput"
import CurrencyInput from 'react-currency-input-field';
import CancelModal from "../CancelModal"
import UnitSizesService from "services/Admin/UnitSizesService";
import { useDispatch, useSelector } from "react-redux";
import { appendFilters } from "store/adminFilter/actions";

const languages = ["en", "ar", "zh", "ru"]
const initialState = {
    en: "",
    ar: "",
    ru: "",
    zh: "",
    descrip_en: "",
    descrip_ar: "",
    descrip_zh: "",
    descrip_ru: "",
    selectedFinishingType: null,
    selectUnitType: null,
    unit_floor_num: "",
    unit_size: "",
    bedRoom_num: "",
    bathroom_num: "",
    selectedCatogory: null,
    selectedBulding: null,
    price: "",
    payment_method: {
        label: "Installment",
        value: "Installment"
    },
    hasBasement: false,
    basementSize: "",
    hasRoof: false,
    roofSize: "",
    hasGarden: false,
    gardenSize: "",
    hasBool: false,
    boolSize: "",
    hasMultiFloor: false,
    floorSize: "",
    construction_status: "",
    delivery_date: "",
    // sale_status:"",
    built_up_area: '',
    sizes: [],
    title_before_number:'',
    title_number_from: '',
    title_number_to: '',
    amenitiesOther: "",
}
const PropertyForm = (props) => {
    const [uploadState, setUploadState] = useState(false)
    const [loading, setLoading] = useState(false)
    const [goOut, setGoOut] = useState(false)
    const [formData, setFormData] = useState(initialState)
    const [mediaIds, setMediaIds] = useState([])
    const [videosIds, setVideosIds] = useState([])
    const [catogoryOptions, setCatogoryOptions] = useState([])
    const [buildingOpttions, setBuildingOpttions] = useState([])
    const [FinishingOptions, setFinishingOptions] = useState([])
    const [unitTypeOptions, setUnitTypeOptions] = useState([])
    const [editProperty, setEditPropery] = useState(null)
    const [unitSizesOptions, setUnitSizesOptions] = useState([])
    const [modal, setModal] = useState(false)
    const [addNew, setAddNew] = useState(false)
    const formRef = useRef()
    const filterData = useSelector(state => state.adminFilter)
    const dispatch = useDispatch()
    const buildingService = new BuildingService()
    const categoriesService = new CategoriesService()
    const propertyService = new PropertyService()
    const unitSizesService = new UnitSizesService()
    const [error, setError] = useState({
        unit_code: false,
        built_up_area: false,
        err: []
    })

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        })

        unitSizesService.getDropDown().then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: item.name.en ? item.name.en : item.name,
                    value: item.id
                }
            })
            setUnitSizesOptions(newOptions)
        })

        dispatch(appendFilters({addProperty: 'property'}))
    }, [])

    useEffect(() => {
        if (editProperty) {
            setFormData({ ...editProperty })
            setMediaIds(editProperty.mediaIds)
            setVideosIds(editProperty.videosIds)
        }
    }, [editProperty])

    const handleFieldChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const updatedAttachment = (attachments, type) => {
        if (type === "media_id") {
            setMediaIds([...mediaIds, ...attachments])
        } else {
            setVideosIds([...videosIds, ...attachments])
        }
    }

    const deleteAttachment = (Items, type) => {

        if (type === "media_id") {
            let updatedMedia = mediaIds.filter(item => item.id != Items[0].id)
            setMediaIds(updatedMedia)
        } else {
            let updatedMedia = videosIds.filter(item => item.id != Items[0].id)
            setVideosIds(updatedMedia)
        }
    }

    const deleteHandler = (id) => {
        propertyService.remove(id).then(response => {
            if (response && response.status === SuccessOk) {
                toast.success(response.data.success)
                props.deleteProperty(id)
                if (editProperty?.id === id) {
                    setFormData(initialState)
                    setEditPropery(null)
                    setMediaIds([])
                    setVideosIds([])
                }
             }
        })
    }

    useEffect(() => {
        const id = props ?.compoundId
             buildingService.getDropDown(id).then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: item.name.en,
                    value: item.id
                }
            })
            setBuildingOpttions(newOptions)
        })
    }, [props.compoundId])

    useEffect(() => {
        const id = formData ?.selectedBulding ?.value
             categoriesService.getDropDown(id).then(res => {
            const newOptions = res.data.map(item => {
                return {
                    label: item.name.en ? item.name.en : item.name,
                    value: item.id
                }
            })
            setCatogoryOptions(newOptions)
        })
    }, [formData.selectedBulding])

    const handleValidSubmit = () => {
        // if (!!formData.price && formData.price === "0") {
        //     toast.error(" Price is required and shall be greater than zero ")
        //     return
        // }
        // else if (!formData.payment_method){
        //     toast.error(" please select Payment Type")
        //     return
        // } else if (!formData.selectedCatogory){
        //     toast.error(" please select Catogory")
        //     return
        // }else if (!formData.selectedFinishingType){
        //     toast.error(" please select Finishing Type")
        //     return
        // }else if (!formData.selectUnitType){
        //     toast.error("Please select Unit Type")
        //     return
        // }
        let check = false
        let err= []
        formData?.sizes?.map((size,index)=>{
            let test={}
            if(!size.label){
                test['label'] = true
            }
            if(!size.value){
                test['value'] = true
            }
            if(test['value'] || test['label']){
                err.push({index: index, ...test})
                check = true
            }
        })
        if((!formData?.unit_code && filterData?.addProperty == 'property') || !formData?.built_up_area || check){
            let errors = {}
            if(!formData?.unit_code && filterData?.addProperty == 'property'){
                errors['unit_code'] = true
            }
            if(!formData?.built_up_area ){
                errors['built_up_area'] = true
            }
            
            setError({...error, ...errors, err})
            return
        }
        
        // let options = []
        // if (formData.hasBasement) options.push({ name: "basement", area: parseInt(formData.basementSize) })
        // if (formData.hasRoof) options.push({ name: "roof", area: parseInt(formData.roofSize) })
        // if (formData.hasGarden) options.push({ name: "garden", area: parseInt(formData.gardenSize) })
        // if (formData.hasBool) options.push({ name: "bool", area: parseInt(formData.boolSize) })
        // if (formData.hasMultiFloor) options.push({ name: "doblex", area: parseInt(formData.floorSize) })
        const sizesData = formData?.sizes?.map((item)=>{
            return {
                label: item?.label?.label,
                value: item?.value
            }
        })

        const data = {
            description: {},
            compound_id: props?.compoundId,
            size: formData?.built_up_area,
            // sale_status:formData.sale_status,
            sale_status: "Left",
            floor: formData?.unit_floor_num,
            price: formData?.price,
            bedrooms: formData?.bedRoom_num,
            bathrooms: formData?.bathroom_num,
            payment_method: formData?.payment_method?.value,
            category_id: formData?.selectedCatogory?.value,
            finishing_type_id: formData.selectedFinishingType?.value,
            unit_type_id: formData?.selectUnitType?.value,
            images_ids: [...mediaIds]?.map(item => item?.id),
            videos_ids: [...videosIds]?.map(item => item?.id),
            payment_plans: [],
            construction_status: formData?.construction_status,
            delivery_date: `${formData?.delivery_date}-01`
        }
        if(filterData?.addProperty == "property") data["name"] = { en: formData?.unit_code }
        if(filterData?.addProperty == "properties") {
            data["name"] = {en : formData.title_before_number}
            data["title_number_from"] = formData.title_number_from
            data["title_number_to"] = formData.title_number_to
        }
        if(formData?.sizes?.length > 0) data["sizes"] = sizesData
        // if(options.length > 0) data["options"] = options
        if(!!formData?.amenitiesOther.label || formData.amenities?.length > 0){
            let newAmenities= formData.amenities?.filter(item => item.label !== "Other")
            data["amenities"] = [...newAmenities,!!formData?.amenitiesOther.label && formData?.amenitiesOther]
        }
        // if(formData?.amenities?.length > 0) data["amenities"] = formData?.amenities
        if (formData.selectedBulding) data["building_id"] = formData.selectedBulding.value,
        
        languages.forEach(language => {
            if (formData[language]?.length) {
                data.name[language] = formData[`${language}`]
            }
        })

        languages.forEach(language => {
            if (formData[`descrip_${language}`]?.length) {
                data.description[language] = formData[`descrip_${language}`]
            }
        })
        setLoading(true)
        if (editProperty ?.id) {
            propertyService.update(editProperty ?.id, data).then(response => {
                if (response && response.status === SuccessOk) {
                    toast.success("Propert has been updated")
                    if (goOut) {
                        props ?.history ?.push(`${adminPrefix}/Admin-developer/compound-list`);
                    } else if (addNew) {
                        setLoading(false)
                        props.updatePropertyList(editProperty ?.id, {
                            ...formData,
                            id: editProperty ?.id,
                            mediaIds: mediaIds,
                            videosIds: videosIds,
                        })
                        formRef.current.reset()
                        setAddNew(false)
                        setFormData(initialState)
                        setMediaIds([])
                        setVideosIds([])
                    }
                    else {
                        props.updatePropertyList(editProperty ?.id, {
                            ...formData,
                            id: editProperty ?.id,
                            mediaIds: mediaIds,
                            videosIds: videosIds,
                        })
                        formRef.current.reset()
                        setFormData(initialState)
                        setMediaIds([])
                        setVideosIds([])
                        props.nextFormStep()
                    }
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    })
                } else {
                    setLoading(false)
                }
            })
        } else {
            propertyService.create(data).then(response => {
                if (response && response.status === SuccessCreated) {
                    toast.success("New Property has been added")
                    if (goOut) {
                        props ?.history ?.push(`${adminPrefix}/Admin-developer/compound-list`);
                    } else if (addNew) {
                        setLoading(false)
                        setFormData(initialState)
                        props.updatePropertyList(undefined, {
                            ...formData,
                            id: response.data[0],
                            mediaIds: mediaIds,
                            videosIds: videosIds,
                        })
                        formRef.current.reset()
                        setAddNew(false)
                        setFormData(initialState)
                        setMediaIds([])
                        setVideosIds([])
                    } else {
                        props.updatePropertyList(undefined, {
                            ...formData,
                            id: response.data[0],
                            mediaIds: mediaIds,
                            videosIds: videosIds,
                        })
                        formRef.current.reset()
                        setAddNew(false)
                        props.nextFormStep()
                        setMediaIds([])
                        setVideosIds([])
                    }
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    })
                } else {
                    setLoading(false)
                }
            })
        }
    }

    const getMaxFloorNumber=(id)=>{
     const building= props.BuildingData.find(building=>building.id===id)
     return building.floor_num 
    }

    return (
        <AvForm ref={formRef} onValidSubmit={(e, v) => {
            handleValidSubmit()
        }}>
            {<Row className="py-3">
                {props ?.propertyData ?.map((item, index) => {
                    return (
                        <Col md={4} sm={6} key={index}>
                            <Card className="mb-3">
                                <CardBody className="p-0">
                                    <CardImg src={item ?.mediaIds[0] ?.path || blankImg} className="imgCard"></CardImg>
                                    <CardText className="pt-2 text-black ps-2  fw-bold">{item.en}</CardText>
                                    <CardText className="text-black   fw-bold d-flex  m-2 justify-content-between">
                                        <button type="button" className="btn btn-primary me-2" onClick={() => setEditPropery(item)}>Edit</button>
                                        <button type="button" className="btn btn-danger" onClick={() => deleteHandler(item.id)}>Delete</button>
                                    </CardText>
                                </CardBody>
                            </Card>
                        </Col>
                    )
                })}
            </Row>}
            <Card >
                <CardBody>
                    <Row className="justify-content-end mb-3">
                        <Col md={2}>
                        <div className="mb-2">
                                <button
                                    className="btn btn-primary btnHeight px-lg-4"
                                    type="button"
                                    onClick={()=>{
                                        dispatch(appendFilters({addProperty: filterData?.addProperty == 'property' ? 'properties' : 'property'}))
                                    }}
                                >
                                    {filterData?.addProperty == 'property' ? 'Add Properties' : 'Add Property'}
                                    </button>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                    {filterData?.addProperty == 'property' && <Col md={6} className="mb-3">
                            <label className={`${error.unit_code && 'error-text'}`}>Unit Code (required)</label>
                            <AvField
                                name='unit_code'
                                bsSize="lg"
                                value={formData.unit_code}
                                onChange={(e => {
                                    handleFieldChange(e)
                                    setError({...error, unit_code: false})
                                })}
                                placeholder={'Unit Code'}
                                validate={{
                                    pattern: {value: '/^[a-zA-Z0-9 ]+$/', errorMessage: `Unit Code Format is invalid`}
                                }}
                            />
                            {error.unit_code && <span className="error-text font-size-11">This Field is required</span>}
                        </Col>}
                        {filterData?.addProperty == 'properties' && <><Col md={6} className="mb-3">
                            <label>Title before number (optional)</label>
                            <AvField
                                name='title_before_number'
                                bsSize="lg"
                                value={formData.title_before_number}
                                onChange={(e => {
                                    handleFieldChange(e)
                                })}
                                placeholder={'Title before number'}
                                validate={{
                                    pattern: {value: '/^[a-zA-Z0-9 ]+$/', errorMessage: `Unit Code Format is invalid`}
                                }}
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <AvField
                                name={"title_number_from"}
                                label={"From the Floor"}
                                bsSize="lg"
                                value={formData?.title_number_from}
                                required
                                errorMessage={"This field is required" }
                                onChange={(e => handleFieldChange(e))}
                                validate={{
                                    pattern: {value: '/^[0-9]+$/', errorMessage: "This field is invalid!"}
                                }}
                                placeholder={'From the Floor'}
                                type="number"
                                min={"0"}
                                max={formData?.title_number_to}
                            />
                        </Col>
                        <Col md={3} className="mb-3">
                            <AvField
                                name={"title_number_to"}
                                label={"To the Floor"}
                                bsSize="lg"
                                value={formData?.title_number_to}
                                onChange={(e => handleFieldChange(e))}
                                required
                                validate={{
                                    pattern: {value: '/^[0-9]+$/', errorMessage: "This field is invalid!"}
                                }}
                                errorMessage={"This field is required"}
                                placeholder={'To the Floor'}
                                type="number"
                                pattern='/^[0-9]+$/'
                                min={formData.title_number_from}
                                // max={floorLimit}
                            />
                        </Col>
                        </>}
                        
                        <Col md={6}>
                            <label>Building</label>
                            <Select
                                placeholder='Select'
                                options={buildingOpttions}
                                className='mb-3 '
                                onChange={data => setFormData({ ...formData, selectedBulding: data, selectedCatogory: null })}
                                value={formData.selectedBulding}
                                setOptions={options => setBuildingOpttions(options)}
                            />
                        </Col>
                        <Col md={6}  >
                            <AvField
                                className="mb-3"
                                name={"unit_floor_num"}
                                label={"Unit Floor"}
                                bsSize="lg"
                                onChange={(e => handleFieldChange(e))}
                                // required
                                // errorMessage="This field is required"
                                value={formData.unit_floor_num}
                                placeholder={"Floor Number"}
                                type="number"
                                pattern='/^[0-9]+$/'
                                 min="1"
                                max={formData.selectedBulding ? getMaxFloorNumber(formData.selectedBulding.value):"200"}

                            />
                        </Col>
                        <Col md={6}>
                            <label>Category</label>
                            <Select
                                placeholder='Select'
                                options={catogoryOptions}
                                className='mb-3 '
                                onChange={data => setFormData({ ...formData, selectedCatogory: data })}
                                value={formData.selectedCatogory}
                                setOptions={options => setCatogoryOptions(options)}
                            />
                        </Col>
                        {/* <Col md={6}  >
                            <AvField
                                className="mb-3"
                                name={"unit_size"}
                                label={"Apartment Size"}
                                bsSize="lg"
                                value={formData.unit_size}
                                onChange={(e => handleFieldChange(e))}
                                // required
                                // errorMessage="This field is required"
                                placeholder={'Size'}
                                type="number"
                                pattern='/^[0-9]+$/'
                                min={"1"}
                            />
                        </Col> */}
                        <Col md={6}  >
                            <AvField
                                className="mb-3"
                                name={"bedRoom_num"}
                                label={"No. Of Bedrooms"}
                                bsSize="lg"
                                value={formData.bedRoom_num}
                                onChange={(e => handleFieldChange(e))}
                                // required
                                // errorMessage="This field is required"
                                placeholder={'bedroom Number'}
                                type="number"
                                pattern='/^[0-9]+$/'
                                min={"1"}
                                max={"20"}
                            />
                        </Col>
                        <Col md={6}  >
                            <AvField
                                className="mb-3"
                                name={"bathroom_num"}
                                label={"No. Of Bathroom"}
                                bsSize="lg"
                                value={formData.bathroom_num}
                                onChange={(e => handleFieldChange(e))}
                                // required
                                // errorMessage="This field is required"
                                placeholder={'bathroom Number'}
                                type="number"
                                pattern='/^[0-9]+$/'
                                min={"1"}
                                max={"20"}
                            />
                        </Col>
                        <Col md={6}>
                            <SelectOptions
                                label='Finishing'
                                placeholder='Select'
                                options={FinishingOptions}
                                handleSelectChange={(data) => {
                                    setFormData({ ...formData, selectedFinishingType: data });
                                }}
                                selectedOption={formData.selectedFinishingType}
                                Service={FinishingTypesService}
                                setOptions={(options) => {
                                    setFinishingOptions(options)
                                }}
                            />
                        </Col>
                        {/* <Col md={6}>
                            <label>Payment Type</label>
                            <Select
                                placeholder='Select'
                                options={payment_methods}
                                className='mb-3 p-1'
                                onChange={(data) => {
                                    setFormData({ ...formData, payment_method: data });

                                }}
                                value={formData.payment_method}
                            />
                        </Col> */}
                        <Col md={6}>
                            <SelectOptions
                                label='Unit Type'
                                placeholder='Select'
                                options={unitTypeOptions}
                                handleSelectChange={(data) => {
                                    setFormData({ ...formData, selectUnitType: data });
                                }}
                                selectedOption={formData.selectUnitType}
                                Service={UnitTypesService}
                                setOptions={(options) => {
                                    setUnitTypeOptions(options)
                                }}
                            />
                        </Col>
                        
                        <Col md={6}  className="mb-3">
                            <AvField
                                        name={"construction_status"}
                                        label={"Development Status"}
                                        bsSize="lg"
                                        // required
                                        value={formData.construction_status}
                                        onChange={e => handleFieldChange(e)}
                                        placeholder={'Development Status'}
                                        type="text"
                                        // errorMessage="This field is required"
                            />
                        </Col>
                        <Col md={6}  >
                            <AvField
                                        className="mb-3"
                                        name={"delivery_date"}
                                        label={"Development Date (Optional)"}
                                        bsSize="lg"
                                        // required
                                        value={formData.delivery_date}
                                        onChange={e => handleFieldChange(e)}
                                        placeholder={'Development Date'}
                                        type="month"
                                        // errorMessage="This field is required"
                            />
                        </Col>
                                
                        <Col md={6} className="price-input"  >
                            <Label>Price</Label>
                            <CurrencyInput
                                id="price"
                                className="mb-3"
                                name="price"
                                placeholder="price"
                                value={formData.price}
                                allowNegativeValue={false}
                                decimalsLimit={2}
                                onValueChange={(value, name) => {
                                    setFormData({ ...formData, price: value })
                                }}
                            />
                            {/* <PriceInput
                                className="mb-3"
                                name={"price"}
                                bsSize="lg"
                                label={"Price"}
                                placeholder={"Price"}
                                type="number"
                                price={formData.price}
                                handleFieldChange={handleFieldChange}
                                min={"1"} /> */}
                        </Col>
                        {/*  <Row className="mb-4">
                       <Label>Sale Status</Label>
                      <Col md={6}>
                            <AvRadioGroup required inline name="sale_status" value={formData.sale_status} required onChange={handleFieldChange} >
                                <AvRadio label="Left" value="Left" />
                                <AvRadio label="Bought" value="Bought" />
                            </AvRadioGroup>
                        </Col>
                       </Row> */}
                        
                        {Language.LIST.map((lan, index) => {
                            return (
                                <Col md={12} key={index} >
                                    <AvField
                                        className="mb-3"
                                        name={lan.descrip_name}
                                        label={`Description (${lan.name})`}
                                        bsSize="lg"
                                        value={formData[`${lan.descrip_name}`]}
                                        onChange={(e => handleFieldChange(e))}
                                        required={false}
                                        type="textarea"
                                        placeholder={lan.name === "en" ? 'Unit Description' : lan.name === "ar" ? "وصف الوحدة" : lan.name === "zh" ? "開羅" : "Каир"}
                                    />
                                </Col>
                            )
                        })}
                    </Row>
                </CardBody>
            </Card >

            <Card className="my-4">
                <CardBody>
                    <Row className="">
                        <h5>Unit Areas</h5>
                        <Col md={6} className='mt-2'>
                            <Label className={`${error.built_up_area && 'error-text'}`}>Total Builtup Area (Required)</Label>
                            <AvField
                                    name="built_up_area"
                                    bsSize="lg"
                                    // required
                                    onChange={e => {
                                        setFormData({...formData, built_up_area: e.target?.value })
                                        setError({...error, built_up_area: false})
                                    }}
                                    type='number'
                                    value={ formData?.built_up_area}
                                    placeholder={"Total Builtup Area"}
                                    // validate={{
                                    //     required: {value: error.built_up_area, errorMessage: 'This Field is required'}
                                    // }}
                            />
                            {error.built_up_area && <span className="error-text font-size-11 mb-3">This Field is required</span>}
                        </Col>
                        <Col md={6}></Col>
                        {formData?.sizes?.length > 0 && formData?.sizes?.map((size, index) =>{
                            return <Row key={index}>
                            <Col md={6} className='mt-3'>
                                <Label className={`${error?.err[`${index}`]?.value && 'error-text'}`}>
                                    {!!size.label ? size?.label?.label : 'Location'}
                                </Label>
                                <AvField
                                    name={`size${index}`}
                                    bsSize="lg"
                                    onChange={e => {
                                        const value = e.target?.value
                                        const updatedSizes = formData?.sizes?.map((sizeItem, sizeIndex) => {
                                            if (index === sizeIndex) {
                                                return {
                                                    ...sizeItem,
                                                    value: value
                                                }
                                            }
                                            return sizeItem
                                        })
                                        setFormData({ ...formData, sizes: [...updatedSizes] })
                                        const updatedError = error?.err?.map((errItem, errIndex) => {
                                            if (index === errIndex) {
                                                return {
                                                    ...errItem,
                                                    value: false
                                                }
                                            }
                                            return errItem
                                        })
                                        setError({ ...error, err: [...updatedError] })
                                    }}
                                    type='number'
                                    value={size?.value}
                                    placeholder={"Location"}
                                />
                                {error?.err[`${index}`]?.value && <span className="error-text font-size-11 mb-3">This Field is required</span>}
                            </Col>
                            <Col md={5} className='mt-3'>
                                <Label className={`${error?.err[`${index}`]?.label && 'error-text'}`}>
                                Area Type
                                </Label>
                                
                                <Select
                                    placeholder='Select'
                                    options={unitSizesOptions}
                                    onChange={e => {
                                        const value = e
                                        const updatedSizes = formData?.sizes?.map((sizeItem, sizeIndex) => {
                                            if (index === sizeIndex) {
                                                return {
                                                    ...sizeItem,
                                                    label: value
                                                }
                                            }
                                            return sizeItem
                                        })
                                        setFormData({ ...formData, sizes: [...updatedSizes] })
                                        setUnitSizesOptions(unitSizesOptions.filter(option=> e?.value !== option?.value))
                                        const updatedError = error?.err?.map((errItem, errIndex) => {
                                            if (index === errIndex) {
                                                return {
                                                    ...errItem,
                                                    label: false
                                                }
                                            }
                                            return errItem
                                        })
                                        setError({ ...error, err: [...updatedError] })
                                    }}
                                    value={size.label}
                                />
                                {error?.err[index]?.label && <span className="error-text font-size-11 mb-3">This Field is required</span>}
                            </Col>
                            <Col md={1} className="d-flex justify-content-end my-2">
                                    <button
                                        className="btn btn-light"
                                        type="button"
                                        onClick={() => {
                                            !!size?.label && setUnitSizesOptions([...unitSizesOptions, size.label])
                                            const updatedSizes = formData?.sizes.filter((_, ind) => ind !== index)
                                            setFormData({ ...formData, sizes: [...updatedSizes] })
                                        }}
                                        style={{ color: "red", fontWeight: "700",height: "min-content", margin: "50% auto 0" }}
                                    >X</button></Col>
                            </Row>
                        }) }
                        
                        <Col md={12} className='mt-3'>
                            <button type="button" className="btn btn-success"
                                onClick={()=> setFormData({...formData, sizes: [...formData?.sizes, {
                                    label: null,
                                    value: ''
                                }]})}>
                                Add New Additional Area
                            </button>
                        </Col>
                    </Row>
                </CardBody>
            </Card >

            {/* {UnitOptions.LIST.map((option, index) => {
                return (
                    <Card key={index} >
                        <CardBody>
                            <Row className="mb-4">
                                <Col><h6>{option.label}</h6></Col>
                                <Col className="d-flex flex-row-reverse">
                                    <div className='form-check form-switch form-switch-md mb-1'>
                                        <AvField
                                            name={option.has}
                                            checked={formData[`${option.has}`]}
                                            value={formData[`${option.has}`]}
                                            type='checkbox'
                                            className='form-check-input'
                                            id='has_status'
                                            onChange={e => {
                                                setFormData({ ...formData, [e.target.name]: e.target.checked });

                                            }}
                                            // required={formData[`${option.has}`] ? true : false}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            {formData[`${option.has}`] &&
                                <Row>
                                    <Col md={6} >
                                        <AvField
                                            className="mb-3"
                                            name={`${option.size}`}
                                            label={"Size"}
                                            bsSize="lg"
                                            value={formData[`${option.size}`]}
                                            onChange={(e => handleFieldChange(e))}
                                            // required
                                            placeholder={option.placeholder}
                                            type="number"
                                            min={"1"}
                                        />
                                    </Col>
                                </Row>}
                        </CardBody>
                    </Card >
                )
            })
            } */}
            <Card>
                <CardBody>
                    <Col md={6}>
                        <label>Amenities</label>
                        <Select
                            label='Compound '
                            placeholder='Select'
                            options={[...adminAmenitiesOptions, { label: "Other", value: "Other" }]}
                            className='mb-3 '
                            onChange={(data) => {
                                setFormData({ ...formData, amenities: data })
                            }}
                            value={formData.amenities}
                            isMulti={true}
                        />
                    </Col>
                    {!!formData?.amenities?.length && (formData.amenities.find(item => item.label === "Other") || !!formData?.amenitiesOther?.label) && <Col md={12}  >
                        <AvField
                            className="mb-0"
                            type="textarea"
                            label="Amenities Name"
                            name={"amenitiesOther"}
                            bsSize="lg"
                            value={formData?.amenitiesOther?.label}
                            minLength={formData?.amenitiesOther?.label === "" ? 1 : 2}
                            onChange={e => setFormData({...formData, amenitiesOther: {
                                value: e.target.value,
                                label: e.target.value,
                                en: e.target.value,
                            }})}
                            required
                            errorMessage="This field is required"
                            placeholder={'Amenities Name'}
                        />
                    </Col>}
                </CardBody>
            </Card>
            <Card >
                <CardBody>
                    <Row>
                        <Col md={12}>
                            <FileUpload
                                accept='.jpg,.png,.jpeg,.JPG,.PNG,.JPEG'
                                label='Property Images'
                                attachmentType='media_id'
                                attachmentData={mediaIds}
                                setUpload={()=> {}}
                                updatedAttachment={updatedAttachment}
                                deleteAttachment={deleteAttachment}
                                multiple
                                setUploadState={setUploadState}
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card >
            <Card >
                <CardBody>
                    <Row>
                        <Col md={12}>
                            <FileUpload
                                accept='.mp4'
                                label='Property Videos'
                                attachmentType='videos_id'
                                attachmentData={videosIds}
                                updatedAttachment={updatedAttachment}
                                deleteAttachment={deleteAttachment}
                                setUpload={()=> {}}
                                multiple
                                setUploadState={setUploadState}
                            />
                        </Col>
                    </Row>
                </CardBody>
            </Card >
            <Row>
                {!props.fromParams && <Col md={6}>
                    <button
                        type="submit"
                        className="bg-light text-success border-0 btn-hover"
                        onClick={() => {
                             setAddNew(true)
                        }}
                        disabled={uploadState ? true : loading ? true : false}
                    >
                        <i className="fas fa-plus-circle"></i>
                        &nbsp;Submit & Add Another Property
                    </button>
                </Col>
                }
            </Row>
            {props.fromParams ? <Row className="mb-4 d-flex flex-row-reverse">
                <Col md={4} className=" d-flex flex-row-reverse">
                    <Button type="submit"
                     disabled={uploadState ? true : loading ? true : false}
                        onClick={() => {
                            setGoOut(true)
                        }} className="btn btn-success btnHeight">Submit</Button>
                </Col>

            </Row> :
                <Row className="mt-4">
                    <Card>
                        <CardBody>
                            <Row className="d-flex justify-content-between">
                                <Col md={2}>
                                    <button type="button" onClick={() => setModal(true)} className="btn btn-light btnHeight  w-100  ">Skip</button>
                                </Col>
                                <Col md={2} className="d-flex flex-row-reverse">
                                    <button type="submit"
                                     className="btn btn-success btnHeight  w-100 "
                                     disabled={uploadState ? true : loading ? true : false}
                                     >Continue</button>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                </Row>}
            <CancelModal modal={modal}
                toggle={() => setModal(!modal)}
                btnOne="Continue"
                btnTwo="Skip"
                btnTwoOclick={() => {
                    props.nextFormStep()
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    })
                }}
                btnOneClick={() => setModal(false)}
            />

        </AvForm>
    )
}

export default PropertyForm 